import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#162E3B] border-t border-[#FFD82D]/10 text-white py-8 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-center justify-between gap-4">

        {/* Brand/Copyright info */}
        <div className="text-center md:text-left">
          <p className="text-sm text-gray-300">
            {t('footer.rights', { year: currentYear })}
          </p>
        </div>

        {/* Social Links */}
        <div className="flex items-center space-x-6">
          <a
            className="text-white hover:text-[#FFD82D] text-2xl transition-colors duration-200 p-2 focus:outline-none focus:ring-2 focus:ring-[#FFD82D] rounded-full"
            target="_blank"
            rel="noreferrer"
            href="https://www.instagram.com/nevski.fit/"
            aria-label={t('footer.instagram')}
          >
            <FontAwesomeIcon icon={faInstagram} />
          </a>
          <a
            className="text-white hover:text-[#FFD82D] text-2xl transition-colors duration-200 p-2 focus:outline-none focus:ring-2 focus:ring-[#FFD82D] rounded-full"
            target="_blank"
            rel="noreferrer"
            href="https://www.facebook.com/profile.php?id=100092708290652"
            aria-label={t('footer.facebook')}
          >
            <FontAwesomeIcon icon={faFacebook} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
